// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using the
// PascalCased version of their file name.

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

// https://vite.dev/guide/features#glob-import
const baseComponents = import.meta.glob(
    // Only "_base-" prefixed .vue files in this directory, not in subdirectories
    './_base-*.vue',
    { eager: true }
)

export const globalComponents = Object.entries(baseComponents).reduce((components, [fileName, componentConfig]) => {
    // Get the PascalCase version of the component name
    const componentName = upperFirst(
        camelCase(
            fileName
                // Remove the "./_" from the beginning
                .replace(/^\.\/_/, '')
                // Remove the file extension from the end
                .replace(/\.\w+$/, '')
        )
    )
    const component = componentConfig.default || componentConfig

    // A `<script setup>` SFC only infers a name from its filename, so these would
    // otherwise identify themselves as `_base-dropdown` — in devtools, in runtime
    // warnings, and to anything that resolves a component by name.
    if (!component.name) component.name = componentName

    components[componentName] = component
    return components
}, {})

export function registerGlobalComponents(app) {
    Object.entries(globalComponents).forEach(([componentName, component]) => {
        app.component(componentName, component)
    })
}
